import React from 'react';

import {StepViewGenericChoicesField} from '../generic-choices-fields';

import type {StepViewFieldProps} from '../commonprops';

export const StepViewCheckboxField = ({field}: StepViewFieldProps) => (
  <StepViewGenericChoicesField inputType="checkbox" field={field} />
);
